import { FeedMessage } from 'theSource/types';

export const getNextPage = (
  lastPage: FeedMessage[],
  allPages: FeedMessage[][],
  maximumMessagesPerPage: number
): number | undefined =>
  lastPage.length !== maximumMessagesPerPage ? undefined : allPages.length + 1;
